export default {
  // 性别
  gender: [
    {
      value: 1,
      label: '男'
    },
    {
      value: 2,
      label: '女'
    }
  ],
  SchoolTypeS: [
    {
      value: '三本',
      label: '三本'
    },
    {
      value: '二本',
      label: '二本'
    },
    {
      value: '一本',
      label: '一本'
    },
    {
      value: '211',
      label: '211'
    },
    {
      value: '985',
      label: '985'
    }
  ],

  // 企业进行状态
  StateOfEnterpriseProgress: [
    {
      value: 10,
      label: '已签合同'
    },
    {
      value: 9,
      label: '自己公司'
    },
    {
      value: '2',
      label: '2'
    },
    {
      value: 1,
      label: '1'
    },
    {
      value: 0,
      label: '0'
    }
  ],
  // 加班按照那种方式发工资
  PackageOrBase: [
    {
      value: 1,
      label: '按照甲方包工资'
    },
    {
      value: 0,
      label: '按照乙方底工资'
    },
    {
      value: -1,
      label: '其它'
    }
  ],
  // 分级排序
  HierarchicalOrder: [
    {
      value: 0,
      label: 0
    },
    {
      value: 1,
      label: 1
    },
    {
      value: 2,
      label: 2
    },
    {
      value: 3,
      label: 3
    },
    {
      value: 4,
      label: 4
    },
    {
      value: 5,
      label: 5
    },
    {
      value: 6,
      label: 6
    },
    {
      value: 7,
      label: 7
    },
    {
      value: 8,
      label: 8
    },
    {
      value: 9,
      label: 9
    },
    {
      value: 10,
      label: 10
    }
  ],
  // 是否看机会标志
  // JobOpportunity = models.SmallIntegerField(null=True, default=0, verbose_name='是否看工作机会')
  //     # 是否看工作的机会0 代表不看，1代表看机会，2代表已入职
  JobOpportunity: [
    {
      value: '',
      label: '清空机会'
    },
    {
      value: 0,
      label: '不看'
    },
    {
      value: 1,
      label: '看'
    },
    {
      value: 2,
      label: '入职'
    }
  ],
  classification: [
    {
      value: '普通',
      label: '普通'
    },
    {
      value: 'HR',
      label: 'HR'
    },
    {
      value: 'BD',
      label: 'BD'
    },
    {
      value: '销售',
      label: '销售'
    },
    {
      value: '安服',
      label: '安服'
    },
    {
      value: '研发',
      label: '研发'
    },
    {
      value: '财务',
      label: '财务'
    },
    {
      value: '培训',
      label: '培训'
    },
    {
      value: '产品',
      label: '产品'
    },
    {
      value: '猎头',
      label: '猎头'
    },
    {
      value: '品牌',
      label: '品牌'
    },
    {
      value: '渠道',
      label: '渠道'
    },
    {
      value: '设计师',
      label: '设计师'
    },
    {
      value: '采购',
      label: '采购'
    },
    {
      value: '测试',
      label: '测试'
    },
    {
      value: '运营',
      label: '运营'
    },
    {
      value: '市场',
      label: '市场'
    },
    {
      value: '法务',
      label: '法务'
    },
    {
      value: '用户体验',
      label: '用户体验'
    },
    {
      value: 'UED',
      label: 'UED'
    },
    {
      value: '公关',
      label: '公关'
    },
    {
      value: '运维',
      label: '运维'
    },
    {
      value: '解决方案',
      label: '解决方案'
    },
    {
      value: '项目',
      label: '项目'
    }
  ],
  // 学历
  Degree: [
    {
      value: 3,
      label: '大专'
    },
    {
      value: 4,
      label: '本科'
    },
    {
      value: 5,
      label: '统本'
    },
    {
      value: 6,
      label: '硕士'
    },
    {
      value: 7,
      label: '博士'
    },
    {
      value: -1,
      label: '未知'
    }
  ]
}
